import React from 'react';
import styled from '@emotion/styled';
import { v4 as uuidv4 } from 'uuid';

import Radios from '../../../common/Radios';
import Select from '../../../common/Select';
import InputWrapper from '../../../common/InputWrapper';
import Button from '../../../common/Button';

import { radiosData, filterTypes, compareOperations } from './';

const Wrapper = styled('div')`
  .filter-item {
    margin-bottom: 15px;
  }
  .logic-radios {
    display: flex;
    .custom-radio {
      margin-left: 10px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
`;

const getCompareOperations = (filterType) => {
  switch (filterType) {
    case 'PRICE':
    case 'RESTS':
    case 'WEIGHT':
      return [compareOperations[4], compareOperations[5], compareOperations[6]];
    case 'ATTRIBUTE':
      return [compareOperations[4]];
    case 'BRAND_NAME':
    case 'NAME':
      return [compareOperations[4], compareOperations[0], compareOperations[1]];
    default:
      return compareOperations;
  }
};

const getCompareInputType = (filterType) => {
  switch (filterType) {
    case 'PRICE':
    case 'RESTS':
    case 'WEIGHT':
      return 'number';
    default:
      return 'text';
  }
};

const AutoItems = (props) => {
  const { logicMode, filters, handleUpdateFiltersLogicMode, handleUpdateFilters } = props;

  const handleAddFilter = () => {
    const newFilter = {
      id: uuidv4(),
      filterType: filterTypes[0],
      compareOperation: null,
      compareValue: '',
    };
    handleUpdateFilters([...filters, newFilter]);
  };

  const handleDeleteFilter = (index) => {
    const newFilters = filters.slice();
    newFilters.splice(index, 1);
    handleUpdateFilters(newFilters);
  };

  const handleUpdateFilter = (index, key, value) => {
    const newFilters = filters.slice();
    newFilters[index] = { ...newFilters[index], [key]: value };
    if (key === 'filterType') {
      newFilters[index].compareOperation = null;
    }
    if (key !== 'compareValue') {
      newFilters[index].compareValue = '';
    }
    handleUpdateFilters(newFilters);
  };

  return (
    <Wrapper>
      <div className="row" style={{ marginBottom: '15px' }}>
        <div className="col-12">
          <div>Товары должны совпадать по:</div>
          <div className="logic-radios">
            <Radios
              id="logicMode"
              name="logicMode"
              data={radiosData}
              currentValue={logicMode}
              onChange={handleUpdateFiltersLogicMode}
            />
          </div>
        </div>
      </div>
      {filters.map((f, i) => (
        <div key={`filter-${f.id}`} className="row filter-item">
          <div className="col-3">
            <Select
              id={`filterType-${f.id}`}
              value={f.filterType}
              options={filterTypes}
              menuPortalTarget={document.querySelector('body')}
              onChange={(data) => handleUpdateFilter(i, 'filterType', data)}
            />
          </div>
          <div className="col-3">
            <Select
              id={`compareOperation-${f.id}`}
              value={f.compareOperation}
              options={getCompareOperations(f.filterType.value)}
              menuPortalTarget={document.querySelector('body')}
              onChange={(data) => handleUpdateFilter(i, 'compareOperation', data)}
            />
          </div>
          {f.compareOperation ? (
            <div className="col-3">
              {/* <Select
                                id={`compareValue-${f.id}`}
                                type={}
                                menuPortalTarget={document.querySelector('body')}
                                options={[]}
                            /> */}
              <InputWrapper
                noLabel
                id={`compareValue-${f.id}`}
                type={getCompareInputType(f.filterType.value)}
                value={f.compareValue}
                onChange={(e) => handleUpdateFilter(i, 'compareValue', e.target.value)}
              />
            </div>
          ) : null}
          <div className="col-3">
            <Button
              classType="btn-link"
              type="button"
              text={<i className="fe-trash-2" style={{ color: '#6c757d', fontSize: '20px' }} />}
              onClick={() => handleDeleteFilter(i)}
            />
          </div>
        </div>
      ))}
      <button
        type="button"
        className="btn btn-light waves-effect waves-light"
        onClick={handleAddFilter}
      >
        Добавить условие
      </button>
    </Wrapper>
  );
};

export default AutoItems;
